import createErrorClass from '../create-error-class';
import errorCodeManager, { ErrorCodeType } from '../create-error-code';
import ErrorCodes from '@src/error/error-codes';

/**
 * "服务端返回"异常
 * @type {{name, new(...[*]): CustomClass, constructor: *, __proto__, prototype: CustomClass}}
 */
class ServiceResponseError extends createErrorClass('ServiceResponseError', errorCodeManager(ErrorCodes.ServiceResponseError, ErrorCodeType.Warn)) {
  /**
   * @param {ServiceResponse} serviceResponse - 异常数据
   * @param {string} [message] - 异常信息
   */
  constructor(serviceResponse, message) {
    super(message || serviceResponse.message, ErrorCodes.ServiceResponseError);
    // 用于兼容 IE 11
    this.message = message || serviceResponse.message;
    this.constructor = ServiceResponseError;
    // noinspection JSUnusedGlobalSymbols
    this.__proto__ = ServiceResponseError.prototype;
    /**
     * @type {ServiceResponse} serviceResponse - 异常数据
     */
    this.serviceResponse = serviceResponse;
  }
}

export default ServiceResponseError;
